import React from 'react';
import { ISmartProps } from './types';
import { View } from './view';

export type TagProps = Omit<ISmartProps, 'css'>;

export const Tag = React.forwardRef((props: TagProps, ref: any) => {
	const { theme = 'blue-grey', size, ...rest } = props;

	return <View theme={theme} ref={ref} tagSize={size} {...rest} />;
});
